import React, { useCallback, useEffect, useRef, useState } from 'react';
import ImagePickerModal from '../../master/ImagePickerModal';
import { url } from '../../../utils/variables';
import { getDirection, pexios , toast } from '../../../utils/functions';
import Timer from '../../master/Timer';
import addImage from '../../../assets/images/AddImagePlaceholder/addImage.png';
// import addImage from '../../../assets/images/add_image.png';
import { useTranslation } from 'react-i18next';
import Modal from '../../master/Modal';
import VehicleCard from '../../../assets/images/sample_images/car-cart.png';
import VehicleCardBack from '../../../assets/images/sample_images/back-car-cart.png';
import GreenCart from '../../../assets/images/sample_images/green-cart.png';
import Plate from '../../../assets/images/register-samples/plate.png'
import FrontCar from '../../../assets/images/register-samples/front.png'
import BackCar from '../../../assets/images/register-samples/back.png'
import FrontLeftCar from '../../../assets/images/register-samples/left-front.png'
import LeftCar from '../../../assets/images/register-samples/left.png'
import BackLeftCar from '../../../assets/images/register-samples/left-back.png'
import BackRightCar from '../../../assets/images/register-samples/right-back.png'
import RightCar from '../../../assets/images/register-samples/right.png'
import FrontRightCar from '../../../assets/images/register-samples/right-front.png'
import CarCeiling from '../../../assets/images/register-samples/roof.png'
import FrontGlass from '../../../assets/images/register-samples/front-glass.png'
import BackGlass from '../../../assets/images/register-samples/back-glass.png'
import Trunk from '../../../assets/images/register-samples/truck.png'
import UnderTrunk from '../../../assets/images/register-samples/under-trunck.png'
import Motor from '../../../assets/images/register-samples/motor.png'
import PlateChassis from '../../../assets/images/register-samples/chassis-plate.png'
import Chassis from '../../../assets/images/register-samples/chassis.png'
import Cabin from '../../../assets/images/register-samples/cabin.png'
import Kilometr from '../../../assets/images/register-samples/km.png'
import Dashboard from '../../../assets/images/register-samples/dashboard.png'
import RingFrontLeft from '../../../assets/images/register-samples/left-front-ring.png'
import RingBackLeft from '../../../assets/images/register-samples/left-back-ring.png'
import RingBackRight from '../../../assets/images/register-samples/right-back-ring.png'
import RingFrontRight from '../../../assets/images/register-samples/right-front-ring.png'
import { useDispatch, useSelector } from 'react-redux';
import ImageZoom from '../../master/ImageZoom';
import { setRouterData } from '../../../redux/actions';


export default function RegisterImages({changeStep,car_type_id,history}) {
    const videoRef = useRef(null);
    const [notif,setNotif] = useState(true);
    const [camera, setCamera] = useState(false);
    const {user} = useSelector(store=>store)
    const dispatch = useDispatch();

    // const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [content, setContent] = useState('');
    const [imgIndex,setImgIndex] = useState(0)
    const [bgImgIndex,setBgImgIndex] = useState(1)
    const [showPicture,setShowPicture] = useState('')
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         images:[],
    //         extraImages:[],
    //         damagesImages:[],
    //     }
    // }
    const { t, i18n } = useTranslation();
    const [data,setData] = useState({
        images:[],
        // extraImages:[],
        // damagesImages:[],
        // bgImages:[]
    })
    const {routerData} = useSelector(store=>store)
    const register_id = routerData.id
    function renderButton(name) {
        // let img = this.state.images.find(itm => itm.filename === name);
        let img = data.images.find(itm => itm.filename === name);
        return (
            // <img
            //     src={
            //         img ?
            //             `${url}/files?uid=${img.uid}&width=70&height=70` :
            //             addImage
            //     }
            //     style={{width: 70, height: 70,marginTop:10}}
            //     alt='images'
            // />
            img ?
            <img src={`${url}/files?uid=${img.uid}&width=85&height=60`} alt='img'/> :
            'default'
        );
    }
    function finishUpload(image, name, done, type) {
        let { images } = data;
        let fd = new FormData();
        fd.append('id', register_id);
        fd.append('type','register');
        fd.append(name, image);
        pexios('api/upload_image','post', fd,true).then(res => {
            // if (type === 'extra')
            //     extraImages.push(res.data);
            // else if(type === 'damage')
            //     damagesImages.push(res.data)
            // else {
                const index = images.findIndex(itm => itm.filename === name);
                if (index !== -1)
                    images[index] = res.data;
                else
                    images.push(res.data);
                setShowPicture(res.data.uid)
            // }
           setData({
                    images
                });
            done();
        }).catch(err=>{
            console.log(err.response)
        });
    }
    function finishBackgroundImageUpload(image, name) {
        let fd = new FormData();
        fd.append('id', register_id);
        fd.append('type','bg_register');
        fd.append(name, image);
        pexios('/api/upload_background_image','post', fd,true)
    }
    function validate(){
        const { images } = data;
        const filledImages = images.reduce((arr, img) => {
           return [
               ...arr,
               img.filename,
           ];
        }, []);
        const mainImage = [
            {key: t('Vehicle plate'), value: filledImages.includes('plate')},
            {key: t('Vehicle card'), value: filledImages.includes('vehicle_card')},
            {key: t('Vehicle card back'), value: filledImages.includes('vehicle_card_back')},
            {key: t('Front vehicle'), value: filledImages.includes('car-front')},
            {key: t('Back vehicle'), value: filledImages.includes('car-back')},
            {key: t('Left side vehicle'), value: filledImages.includes('car-left')},
            {key: t('Right side vehicle'), value: filledImages.includes('car-right')},
            {key: t('Motor image'), value: filledImages.includes('motor')},
            {key: t('Engraved chassis number'), value: filledImages.includes('chassis')},
            {key: t('Plate chassis'), value: filledImages.includes('plate_chassis')},
            {key: t('Kilometr image'), value: filledImages.includes('kilometer')},
            {key: t('Dashboard'), value: filledImages.includes('dashboard')},
            // {key: 'داخل کابین', value: filledImages.includes('cabin')},
            {key: t('Front glass'), value: filledImages.includes('front_glass')},
            {key: t('Green card'),value: filledImages.includes('green_card')},
        ];
        let conditionImages = [];
        if (car_type_id === 1)
            conditionImages = [
                {key:t('Car ceiling'),value: filledImages.includes('car-ceiling')},
                {key:t('Trunk'),value: filledImages.includes('trunk')},
                {key:t('Under trunk'),value: filledImages.includes('under_trunk')},
                {key: t('Back glass'), value: filledImages.includes('back_glass')},
            ];
        else if([6,7,9].includes(car_type_id))
            conditionImages = [
                {key:t('Tire'),value: filledImages.includes('tire')},
                {key:t('Using'),value: filledImages.includes('using')},
            ];
        let error = '';
        [...mainImage, ...conditionImages].forEach(itm => {
            if (!itm.value) error = `${error}, ${itm.key}`;
        })
        // if (error) toast(`عکس های اجباری ${error} را بارگزاری کنید.`, 'error');
        if (error) {
            toast(t('Upload reqired images',{error:error}), 'error');
            setCamera(false)
        }
        else {
            history.push('/register-video')
        }
        // else changeStep(3);
    }
    function openCamera () {
            try {
                navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} })
                .then(async (stream)=>{
                    if(stream) {
                        setCamera(true)
                        setContent('picker')
                    } 
                    // setTimeout(()=>videoRef.current.srcObject = stream,1000)
                    // setTimeout(()=>notif.current.style.display = 'none',3000)
                })
                .catch(()=>{
                    toast('لطفا برای دسترسی به دوربین تنظیمات خود را مجددا بررسی کنید','error');
                })
            } catch (error) {
                toast('دسترسی به دوربین خود را فعال کنید','error');
                // console.error('Error accessing camera:', error);
            }
          }
    useEffect(() => {
        let close  
        // setContent('loader')
        setLoader(true)
        const startCamera = async () => {
            try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                close = setTimeout(()=>setNotif(false),3000)
                setContent('picker')
                setLoader(false)
            //   close = setTimeout(()=>notif.current.style.display = 'none',3000)
            }
            } catch (error) {
                console.error("Error accessing the camera: ", error);
                toast('دسترسی به دوربین خود را فعال کنید','error');
            }
        };

        // camera && 
        startCamera();
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
            clearTimeout(close)
            }
        };
        }, []);
    useEffect(()=>{
        let timer
        if(content === 'picker'&& allImages.length -1 !== imgIndex) {
            timer = setInterval(()=>{
                backgroundIImageCapturing()
                // setBgImgIndex(prevState => prevState + 1)
            },1000)
        }
        return()=>{
            clearInterval(timer)
        }
    },[content])
    function backgroundIImageCapturing (){
        const image = videoRef.current;
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;
    
            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;
    
            let newWidth = oldWidth;
            let newHeight = oldHeight;
    
            // if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 400)
                    : Math.floor(oldWidth / oldHeight * 400);
                newWidth = longestDimension === 'width' ? 400 : newSize;
                newHeight = longestDimension === 'height' ? 400 : newSize;
            // }
    
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;
    
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                finishBackgroundImageUpload(blob,'image');
            },'image/jpeg', 0.7);
        }
    }
    async function takePicture() {
    // setContent('loader');
    setLoader(true)
    const image = videoRef.current;
    // if(croppable){
    //     setImageToCrop(image)
    //     setCropperModal(true)
    //     setContent('picker');
    //     return;
    // }
    
    if (image) {
        const oldWidth = image.videoWidth;
        const oldHeight = image.videoHeight;

        const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
        const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

        let newWidth = oldWidth;
        let newHeight = oldHeight;

        // if (currentRes > 1080) {
            const newSize = longestDimension === 'width'
                ? Math.floor(oldHeight / oldWidth * 1080)
                : Math.floor(oldWidth / oldHeight * 1080);
            newWidth = longestDimension === 'width' ? 1080 : newSize;
            newHeight = longestDimension === 'height' ? 1080 : newSize;
        // }

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        canvas.toBlob((blob) => {
            finishUpload(blob,allImages[imgIndex].name, () => {
                // setCamera(false);
                // setOpen(false);
                // if (allImages.length -1 === imgIndex) history.push('/register-video')
                // else setImgIndex(prevState => prevState + 1)
                setTimeout(() => setLoader(false), 500);
                // setTimeout(() => setContent('picker'), 500);
            });
        },'image/jpeg', 0.7);
    }
    }
    const allImages = [
        {name: 'vehicle_card',label:'vehicle_card_image',title:t('Vehicle card'),src: VehicleCard},
        {name: 'vehicle_card_back',label:'vehicle_card_back_image',title:t('Vehicle card back'),src: VehicleCardBack},
        {name: 'green_card',label:'green_card',title:t('Green card'),src: GreenCart,rotate:true},
        {name: 'plate',label:'expert_plate',title:t('Vehicle plate'),src: Plate},
        {name: 'car_front',label:'front_image',title:t('Front vehicle'),src: FrontCar},
        {name: 'car_front_left',label:'front_left_image',title:t('Front Left vehicle'),src: FrontLeftCar},
        {name: 'car_left',label:'left_image',title:t('Left side vehicle'),src: LeftCar},
        {name: 'car_back_left',label:'back_left_image',title:t('Back Left vehicle'),src: BackLeftCar},
        {name: 'car_back',label:'back_image',title:t('Back vehicle'),src: BackCar},
        {name: 'car_back_right',label:'back_right_image',title:t('Back Right vehicle'),src: BackRightCar},
        {name: 'car_right',label:'right_image',title:t('Right side vehicle'),src: RightCar},
        {name: 'car_front_right',label:'front_right_image',title:t('Front Right vehicle'),src: FrontRightCar},
        {name: 'car_roof',label:'car_roof',title:t('Car ceiling'),src: CarCeiling},
        {name: 'front_glass',label:'front_glass',title:t('Front glass'),src: FrontGlass},
        {name: 'back_glass',label:'back_glass',title:t('Back glass'),src: BackGlass},
        {name: 'trunk',label:'trunk',title:t('Trunk'),src: Trunk},
        {name: 'under_trunk',label:'under_trunk',title:t('Under trunk'),src: UnderTrunk},
        {name: 'motor',label:'motor',title:t('Motor image'),src: Motor},
        {name: 'plate_chassis',label:'plate_chassis',title:t('Plate chassis'),src: PlateChassis},
        {name: 'chassis',label:'chassis_number',title:t('Engraved chassis number'),src: Chassis},
        {name: 'cabin',label:'cabin',title:t('Cabin'),src: Cabin},
        {name: 'dashboard',label:'dashboard',title:t('Dashboard'),src: Dashboard},
        {name: 'kilometer',label:'kilometer',title:t('Kilometr image'),src: Kilometr},
        {name: 'ring_front_left',label:'ring_front_left',title:t('Ring Front Left'),src: RingFrontLeft},
        {name: 'ring_back_left',label:'ring_back_left',title:t('Ring Back Left'),src: RingBackLeft},
        {name: 'ring_back_right',label:'ring_back_right',title:t('Ring Back Right'),src: RingBackRight},
        {name: 'ring_front_right',label:'ring_front_right',title:t('Ring Front Right'),src: RingFrontRight},
    ]
    function AcceptOrDeclineBtns(type){
        if(type === 'accept') {
            if (allImages.length -1 === imgIndex) {
                pexios('/api/finish_image_progress','post',{id:register_id,type:"bg_register"})
                .then(()=>{
                    toast('پرونده صدور شما با موفقیت تشکیل شد.باتشکر از همکاری شما.');
                    setTimeout(()=>{
                        dispatch(setRouterData({ id:register_id, type: 'register' }));
                        history.push('/register-single');
                    },5000)
                })
                // history.push('/register-video')
            }
            else setImgIndex(prevState => prevState + 1)
        }
        setShowPicture('')
    }
    // render() {
        return (
            <div className='register content'>
                {/* <p className='guide-text mb30 mx10'>برای شروع تصویربرداری لطفا دسترسی به دوربین خود را فعال نمایید</p>
                <div className='d-flex justify-center mt20'>
                    <button className='btn btn-white-purple w-50 btn-circle' onClick={()=> openCamera()}>
                        شروع تصویربرداری
                    </button>
                </div> */}
                <>
                <Modal visible={true}>
                    { loader &&
                        <Modal visible={loader}>
                            <div className='loader-modal'>
                                <i className='fas fa-spinner fa-spin'/>
                            </div>
                        </Modal>
                    }
                    {showPicture &&
                        <Modal visible={true}>
                            <div className='image-modal'>
                                <ImageZoom imgUid={showPicture} rotate/>
                                <div className='d-flex accept-or-decline-btn'>
                                    <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('reject')}><span className='fas fa-times'/></button>
                                    <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('accept')}><span className='fas fa-check'/></button>
                                </div>
                            </div>
                        </Modal>}
                    {
                    // content === 'picker' &&
                        <div className='screen-camera'>
                            <video ref={videoRef} autoPlay playsInline muted style={{ height: '100%'}}></video>
                            {/* {label && carSides.map((item)=> item.label === label &&
                            <> */}
                            {content === 'picker' &&
                            <>
                                {notif &&
                                <div className='tuturial-notif'> 
                                    <i className='fas fa-times' onClick={()=> setNotif(false)}/>
                                        لطفا در بازه زمانی مشخص شده تصاویر درخواستی را بارگذاری نمایید
                                </div>
                                }
                                {/* <img className='upper-image' src={item.image} />                 
                            </>
                            )}  */}
                            {/* <img className='upper-image' src={Frame} />  */}
                            <div className='register-timer'>
                            <Timer seconds={1200} onFinish={()=>history.push('/splash')} />
                            </div>
                            {/* {allImages.map(itm =>  */}
                                <div key={allImages[imgIndex].label}>
                                    <h5 className=' border-bottom image-title'> {allImages[imgIndex].title} </h5>
                                    <img className={`sample-img ${allImages[imgIndex]?.rotate ? 'not-rotate':''}`} src={allImages[imgIndex].src} alt="sample"/>
                                </div>
                            {/* )} */}

                            <div className='d-flex justify-center align-items-center navigate-btns'>
                                <button className='capture-btn' onClick={takePicture}/>
                                {/* <i className='fas fa-times mb25 mr30 close-btn' onClick={()=>setCamera(false)} /> */}
                            </div>
                            </>
                            }
                        </div>
                    }
                </Modal>
                    </>
                {/* <div className='text-box mt20'>
                    <p className='text-justify'>{t('Register Uploading image')}</p>
                </div> */}
                {/* <div className='text-center mt10'>
                    <p className='text-box'>{t('Times left to upload register images')}:</p>
                    <Timer seconds={1200} onFinish={()=>history.push('/splash')} />
                </div> */}
                {/* <div className={`row ${getDirection(i18n.language) === 'leftToRight' && 'flex-row-reverse'}`}> */}
                    {/* <div className='col-6'> */}
                        {/* <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                            {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Vehicle plate')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('plate')}
                                upload={(image, done) => finishUpload(image, done, 'plate')}
                                label='expert_plate'
                            />
                            </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Vehicle card')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('vehicle_card')}
                                upload={(image, done) => finishUpload(image, done, 'vehicle_card')}
                                label='vehicle_card_image'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Vehicle card back')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('vehicle_card_back')}
                                upload={(image, done) => finishUpload(image, done, 'vehicle_card_back')}
                                label='vehicle_card_back_image'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Green card')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('green_card')}
                                upload={(image, done) => finishUpload(image, done, 'green_card')}
                                label='green-card'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Front vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-front')}
                                upload={(image, done) => finishUpload(image, done, 'car-front')}
                                label='front_image'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Back vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-back')}
                                upload={(image, done) => finishUpload(image, done, 'car-back')}
                                label='back_image'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Left side vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-left')}
                                upload={(image, done) => finishUpload(image, done, 'car-left')}
                                label='left_image'
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                    {/* <div className='upload-box'>
                        <p className='upload-text'>{t('Right side vehicle')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('car-right')}
                            upload={(image, done) => finishUpload(image, done, 'car-right')}
                            label='right_image'
                        />
                    </div>
                    <div className='upload-box'>
                        <p className='upload-text'>{t('Front glass')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('front_glass')}
                            upload={(image, done) => finishUpload(image, done, 'front_glass')}
                            label='front_glass'
                        />
                    </div>
                    <div className='upload-box'>
                        <p className='upload-text'>{t('Motor image')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('motor')}
                            upload={(image, done) => finishUpload(image, done, 'motor')}
                            label='motor'
                        />
                    </div>
                    <div className='upload-box'>
                        <p className='upload-text'>{t('Engraved chassis number')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('chassis')}
                            upload={(image, done) => finishUpload(image, done, 'chassis')}
                            label='chassis_number'
                        />
                    </div>
                    <div className='upload-box'>
                        <p className='upload-text'> {t('Plate chassis')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('plate_chassis')}
                            upload={(image, done) => finishUpload(image, done, 'plate_chassis')}
                            label='plate_chassis'
                        />
                    </div> */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>داخل کابین</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={this.renderButton('cabin')}
                                upload={(image, done) => this.finishUpload(image, done, 'cabin')}
                            />
                        </div>
                    </div> */}
                    {/* <div className='upload-box'>
                        <p className='upload-text'>{t('Kilometr image')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('kilometer')}
                            upload={(image, done) => finishUpload(image, done, 'kilometer')}
                            label='kilometer'
                        />
                    </div>
                    <div className='upload-box'>
                        <p className='upload-text'>{t('Dashboard')}</p>
                        <ImagePickerModal
                            disableGallery
                            renderBtn={renderButton('dashboard')}
                            upload={(image, done) => finishUpload(image, done, 'dashboard')}
                            label='dashboard'
                        />
                    </div> */}
                    {/* {
                        car_type_id===1?
                            <>
                                <div className='upload-box'>
                                    <p className='upload-text'>{t('Car ceiling')}</p>
                                    <ImagePickerModal
                                        disableGallery
                                        renderBtn={renderButton('car-ceiling')}
                                        upload={(image, done) => finishUpload(image, done, 'car-ceiling')}
                                        label='car-ceiling'
                                    />
                                </div>
                                <div className='upload-box'>
                                    <p className='upload-text'>{t('Trunk')}</p>
                                    <ImagePickerModal
                                        disableGallery
                                        renderBtn={renderButton('trunk')}
                                        upload={(image, done) => finishUpload(image, done, 'trunk')}
                                        label='trunk'
                                    />
                                </div>
                                <div className='upload-box'>
                                    <p className='upload-text'>{t('Under trunk')}</p>
                                    <ImagePickerModal
                                        disableGallery
                                        renderBtn={renderButton('under_trunk')}
                                        upload={(image, done) => finishUpload(image, done, 'under_trunk')}
                                        label='under_trunk'
                                    />
                                </div>
                                <div className='upload-box'>
                                    <p className='upload-text'> {t('Back glass')}</p>
                                    <ImagePickerModal
                                        disableGallery
                                        renderBtn={renderButton('back_glass')}
                                        upload={(image, done) => finishUpload(image, done, 'back_glass')}
                                        label='back_glass'
                                    />
                                </div>
                            </>:
                            [6,7,9].includes(car_type_id)?
                                <> */}
                                    {/* <div className='col-6'>
                                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                                        {/* <div className='upload-box'>
                                            <p className='upload-text'>{t('Tire')}</p>
                                            <ImagePickerModal
                                                disableGallery
                                                renderBtn={renderButton('tire')}
                                                upload={(image, done) => finishUpload(image, done, 'tire')}
                                                label='tire'
                                            />
                                        </div> */}
                                        {/* </div>
                                    </div>
                                    <div className='col-6'>
                                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                                        {/* <div className='upload-box'>
                                            <p className='upload-text'>{t('Using')}</p>
                                            <ImagePickerModal
                                                disableGallery
                                                renderBtn={renderButton('using')}
                                                upload={(image, done) => finishUpload(image, done, 'using')}
                                            />
                                        </div> */}
                                        {/* </div>
                                    </div> */}
                                {/* </>:null

                    } */}
                    {/* {

                        data.extraImages.map((itm)=>{
                            return(
                                // <div className='col-6' key={itm.id}>
                                //     <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                // <div className='upload-box'>
                                //     <p className='upload-text'>{t('Image of accessories')}</p>
                                //     <img
                                //         src={`${url}/files?uid=${itm.uid}&width=70&height=70`}
                                //         style={{width: 70, height: 70,marginTop:10}}
                                //         alt='images'
                                //     />
                                // </div>
                                //     </div>
                                // </div>
                            )
                        })
                    } */}
                    {/* {

                        data.damagesImages.map((itm)=>{
                            return(
                                <div className='upload-box'>
                                    <p className='upload-text'>{t('Images of damaged positions')}</p>
                                    <img
                                        src={`${url}/files?uid=${itm.uid}&width=70&height=70`}
                                        style={{width: 70, height: 70,marginTop:10}}
                                        alt='images'
                                    />
                                </div>
                            )
                        })
                    } */}
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Completment image')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={<div className='upload-icon-parent'><img src={addImage} alt='images'/></div>}
                                // renderBtn={<img src={addImage} alt='images' style={{width: 70, height: 70,marginTop:10}}/>}
                                upload={(image, done) => finishUpload(image, done, `extra-${data.extraImages.length + 1}`, 'extra')}
                            />
                        </div> */}
                        {/* </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
                        {/* <div className='upload-box'>
                            <p className='upload-text'>{t('Images of damaged positions')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={<div className='upload-icon-parent'><img src={addImage} alt='images'/></div>}
                                upload={(image, done) => finishUpload(image, done, `damage-${data.damagesImages.length + 1}`, 'damage')}
                            />
                        </div> */}
                        {/* </div>
                    </div> */}
                {/* </div> */}
                {/* <div className='d-flex justify-center mt20'>
                    <button className='btn btn-white-purple w-50 btn-circle' onClick={()=>validate()}>
                        {t('Submit')}
                    </button>
                </div> */}
            </div>
        )
    //}

}
